import { Link } from "react-router-dom";
import { GoDeviceDesktop } from "react-icons/go";
import { IoLogoGameControllerB, IoMdHeadset } from "react-icons/io";
import { BsFillTagsFill } from "react-icons/bs";
import "./HeaderTags.css";

export const HeaderTags = () => {
  return (
    <div className="categories h-full grid grid-cols-2 md:grid-cols-4 justify-center items-center gap-4 lg:h-80 lg:grid lg:col-span-2 lg:grid-cols-2 lg:gap-2">
      <Link
        to="/products"
        state={{ category: "gaming" }}
        className="h-full w-full"
      >
        <div className="card relative h-full w-full flex flex-col p-2 gap-1 transition bg-primary rounded-md items-center justify-around shadow-md">
          <IoLogoGameControllerB className="text-7xl text-white" />
          <h1 className="title text-xl text-white font-medium font-Roboto">
            Gaming
          </h1>
        </div>
      </Link>

      <Link
        to="/products"
        state={{ category: "laptop" }}
        className="h-full w-full"
      >
        <div className="card relative h-full w-full flex flex-col p-2 gap-1 transition bg-primary rounded-md items-center justify-around shadow-md">
          <GoDeviceDesktop className="text-7xl text-white" />
          <h1 className="title text-xl text-white font-medium font-Roboto">
            Laptop
          </h1>
        </div>
      </Link>

      <Link
        to="/products"
        state={{ category: "accessories" }}
        className="h-full w-full"
      >
        <div className="card relative h-full w-full flex flex-col p-2 gap-1 transition bg-primary rounded-md items-center justify-around shadow-md">
          <IoMdHeadset className="text-7xl text-white" />
          <h1 className="title text-xl text-white font-medium font-Roboto">
            Accessories
          </h1>
        </div>
      </Link>

      <Link 
      to="/products" state={{ category: null }} className="h-full w-full">
        <div className="card relative h-full w-full flex flex-col p-2 gap-1 transition bg-secondary-200 rounded-md items-center justify-around shadow-md">
          <BsFillTagsFill className="text-7xl text-white" />
          <h1 className="title text-xl text-white font-medium font-Roboto">
            All Category
          </h1>
        </div>
      </Link>
    </div>
  );
};
